import { MultiBreakdownOptionMixin } from '../mixin';
import breakdownTranslatorMixin from '@/mixins/translator/breakdown';

import ChipList from '../../components/ChipList';
import Chip from '../../components/Chip';

import * as C from '../../options/styles';

import BreakdownIcon from '@svgIcons/dashboard/breakdown.svg';

import { isValueExist, changeOrder } from '@util';
import { IFRAME_EVENT_MESSAGE } from '@consts';
import { makeBreakdownFormat, FIELD_KEY, pluckFieldKey } from '../utils';
import { HIDDEN_ROW_IDS } from '@/utils/dashboard';
import { checkOrderRule } from './utils';
import { NOTI_TYPES } from '@/store/dashboardEdit';

export default {
    name: 'MultiBreakdownOption',
    mixins: [MultiBreakdownOptionMixin, breakdownTranslatorMixin],
    props: {
        panelKey: String,
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        canEditCustomBreakdown: {
            type: Boolean,
            default: true,
        },
        panelTitle: String,
        optionTitle: String,
    },
    data() {
        return {
            iframeListeners_: [
                {
                    eventType: IFRAME_EVENT_MESSAGE.UPDATE_BREAKDOWN_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        if (!data || data.panelKey !== this.panelKey) return;
                        const { selectedFields } = data;

                        const updated = R.compose(
                            R.uniqBy(R.prop(FIELD_KEY)),
                            R.map(makeBreakdownFormat)
                        )(selectedFields);
                        this.$emit('update', updated);
                    },
                },
            ],
        };
    },
    computed: {
        title() {
            return (
                this.panelTitle ??
                this.$t('FIELD_PANEL.breakdown.second_panel_title')
            );
        },
        mainGuide() {
            return this.$t('FIELD_PANEL.breakdown.second_panel_main_guide');
        },
        subGuide() {
            return this.$t('FIELD_PANEL.breakdown.second_panel_sub_guide');
        },
    },
    methods: {
        reorderItems({ oldIndex, newIndex }) {
            const updated = changeOrder({
                oldIndex,
                newIndex,
                value: this.currentList,
            });
            const newList = pluckFieldKey(updated);
            const { available, type } = checkOrderRule.call(this, {
                list: newList,
                changeOrder: true,
                selectedChannels: this.selectedChannels,
            });

            if (!available && type) {
                this.addNotiMsg({
                    type: NOTI_TYPES.FAIL,
                    title: this.$t(
                        `NEW_DASHBOARD.row_modal_error_${type.toLowerCase()}`
                    ),
                });
                return;
            }

            this.$emit('update', updated);
        },
        removeItem(item) {
            const targetKey = item[FIELD_KEY];
            const updated = R.filter(
                R.complement(R.propEq(FIELD_KEY, targetKey))
            )(this.currentList);
            this.$emit('update', updated);
        },
        renderItem() {
            const { cursor, renderNoList, currentList, disabled } = this;

            return (
                <C.ItemWrapper>
                    {isValueExist(currentList) ? (
                        <ChipList
                            disabled={disabled}
                            value={currentList}
                            onReorder={this.reorderItems}
                        >
                            {currentList.map((item) => {
                                const itemKey = item[FIELD_KEY];

                                if (HIDDEN_ROW_IDS.has(itemKey)) return;

                                const displayName =
                                    this.getFieldName(item) ??
                                    this.getBreakdownName(item);

                                const status = this.getFieldStatus(item);
                                const isInvalid =
                                    status === C.ITEM_STATUS.INVALID;

                                return this.wrapTooltip({
                                    visible: isInvalid,
                                    title: this.$t(
                                        'EDITABLE_DASHBOARD.breakdown_no_longer_valid'
                                    ),
                                    content: (
                                        <Chip
                                            title={displayName}
                                            status={status}
                                            loading={this.fieldLabelsLoading}
                                            dragCursor={cursor}
                                            sortable
                                            removable
                                            onRemove={() => {
                                                this.removeItem(item);
                                            }}
                                        />
                                    ),
                                });
                            })}
                        </ChipList>
                    ) : (
                        renderNoList(
                            this.$t('EDITABLE_DASHBOARD.list_empty_breakdown')
                        )
                    )}
                </C.ItemWrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderItem } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    children: renderItem(),
                    title:
                        this.optionTitle ??
                        this.$t('NEW_DASHBOARD.row_modal_order_row_title'),
                    icon: <BreakdownIcon class="metric-icon" />,
                    loading: this.fieldLabelsLoading,
                })}
            </C.ComponentWrapper>
        );
    },
};
